var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainLayout',[_c('Transition',{attrs:{"appear":""}},[_c('div',{staticStyle:{"display":"flex","width":"100%","height":"100%","background":"rgba(255, 255, 255, 0.5)"}},[_c('div',{staticStyle:{"margin":"auto","color":"white"}},[_c('div',{staticClass:"loader"},[_vm._v("Loading")]),_c('div',[_vm._v("Please wait for a moment")])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }